document.addEventListener('DOMContentLoaded', function(){
  const ROOT = document.getElementById('gr-journeys');
  if(!ROOT){ console.warn('[Journeys] #gr-journeys not found'); return; }

  // Storage helpers
  const getJSON = (k, fb) => { try { return JSON.parse(localStorage.getItem(k)) ?? fb; } catch { return fb; } };
  const setJSON = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch{} };

  // Read pins from the current system
  function readPins(){ return getJSON('gr_pins', []); }
  function writePins(arr){ setJSON('gr_pins', arr); }

  // Read legacy “namespaced pin” flags (optional)
  function readLegacyPins(){
    const map = { INTJ: '/pages/intj' /* add others as you publish */ };
    const out = [];
    Object.keys(map).forEach(type=>{
      const key = `gr:${type}:v1:pinned`;
      if (localStorage.getItem(key) === 'true') {
        out.push({ id:`profile-${type.toLowerCase()}`, label:`${type} — Journey`, url: map[type], ts:0 });
      }
    });
    return out;
  }

  function listJourneyPins(){
    const current = readPins();
    const legacy  = readLegacyPins();
    // If you want to only show leadership profiles, uncomment the filter below:
    // const onlyProfiles = p => (p?.url||'').includes('/leadership-profiles/');
    // const all = [...current.filter(onlyProfiles), ...legacy];
    const all = [...current, ...legacy];
    const seen = new Set(), dedup = [];
    for (const p of all){
      if (!p || !p.id) continue;
      if (seen.has(p.id)) continue;
      seen.add(p.id); dedup.push(p);
    }
    return dedup;
  }

  function nameFromPin(p){
    if (p.label) return p.label;
    try {
      const seg = new URL(p.url, location.origin).pathname.split('/').filter(Boolean).pop();
      return (seg || 'Journey').toUpperCase();
    } catch { return 'Journey'; }
  }

 const TITLE = document.getElementById('gr-focus-title');


  function render(){
    const pins = listJourneyPins();
    console.log('[Journeys] pins:', pins); // quick sanity check

    if (!pins.length){
      if (TITLE) TITLE.style.display = 'none';
      ROOT.innerHTML = `<div class="gr-j-empty">No focus tools pinned yet. Open a tool and tap “📌 Pin”.</div>`;
      return;
    }

    if (TITLE) TITLE.style.display = '';

    ROOT.innerHTML = pins.map(p=>{
      const title = nameFromPin(p);
      const url   = p.url || '#';
      return `
        <div class="gr-j-card" data-pin-id="${p.id}">
          <div class="gr-j-meta">
            <span class="gr-j-eyebrow">Tool</span>
            <div class="gr-j-title">${title}</div>
          </div>
          <div class="gr-j-actions">
            <a class="gr-j-open" href="${url}">Open →</a>
            <button class="gr-j-unpin" type="button" aria-label="Unpin ${title}">Unpin</button>
          </div>
        </div>`;
    }).join('');
  }

  ROOT.addEventListener('click', function(e){
    const btn = e.target.closest('.gr-j-unpin');
    if(!btn) return;
    const card = e.target.closest('.gr-j-card');
    const id = card?.getAttribute('data-pin-id');
    if(!id) return;
    const next = readPins().filter(p => p.id !== id);
    writePins(next);
    render();
  });

  // initial + cross-tab sync
  render();
  window.addEventListener('storage', (e)=>{ if(e.key==='gr_pins') render(); });
});
